// extracted by mini-css-extract-plugin
export var orderDetails = "_ul-2";
export var orderImage = "_ul-1";
export var orderMeta = "_ul-3";
export var orderSummary = "_ul-0";
export var rightArrow = "_ul-4";